import { useContext } from 'react';
import AuthContext from '../CustomContext';

//---------------------------------------------------------
const useAuth = () => useContext(AuthContext);

export default useAuth;
